export enum ETypesRequisition {
    Requisition = 1,
    Retour = 2,
    Transfert = 3
}